import type { PatchConfig } from '@cowell/shared';

export const DEFAULT_CONFIG: PatchConfig = {
  size: { width: 8, height: 3, isCustom: false },
  lines: [{ text: 'POLICE', size: 'large' }],
  font: 'helvetica-black',
  vinylColorId: 'sheriff-gold',
  placardColorId: 'tactical-black',
  quantity: 1,
};
